import { Paper, styled } from '@mui/material';

export const Container = styled(Paper)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  height: 'calc(100% - 1px)',
  gap: theme.spacing(2)
}));
